var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTriklLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 183.85 183.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #12174d;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 91.93,
    cy: 91.93,
    r: 91.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 47,
    y: 68.14,
    width: 119.92,
    height: 17.51,
    rx: 8.75,
    ry: 8.75,
    transform: "translate(85.7 -53.11) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 52.06,
    y: 92.86,
    width: 60.36,
    height: 17.51,
    rx: 8.75,
    ry: 8.75,
    transform: "translate(95.94 -28.39) rotate(45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 49.37,
    y: 117.03,
    width: 17.4,
    height: 17.51,
    rx: 8.7,
    ry: 8.7,
    transform: "translate(105.95 -4.22) rotate(45)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriklLogo);
export default __webpack_public_path__ + "static/media/triklLogo.b4799182edd8ef04f29cffe01bdd9f63.svg";
export { ForwardRef as ReactComponent };